var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoArrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 16,
    viewBox: "0 0 104 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 19,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sp19-karada-brand-story",
    transform: "translate(-108 -1416)",
    fill: "#1E1E20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0 568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0 504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(108 256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-arrange",
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.015 9.495 6.593 2.402 4.15 9.495l-.73 2.134-1.153 3.364c-.04.115-.326.864-1.057.864-1.173 0-1.211-1-1.211-1.134 0-.173.038-.307.096-.48l4.69-12.86C5.21.23 5.901 0 6.651 0c.326 0 1.23 0 1.73 1.383l4.708 12.86c.039.116.096.307.096.519 0 .653-.5 1.076-1.191 1.076-.557 0-.923-.346-1.095-.845l-1.154-3.364-.73-2.134Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.015 9.524 6.593 2.432 4.15 9.524l-.73 2.134-1.153 3.364c-.04.115-.326.865-1.057.865-1.173 0-1.211-1-1.211-1.134 0-.174.038-.308.096-.48l4.69-12.86C5.21.26 5.901.028 6.651.028c.326 0 1.23 0 1.73 1.383l4.708 12.86c.039.116.096.307.096.519 0 .654-.5 1.076-1.191 1.076-.557 0-.923-.346-1.095-.845l-1.154-3.364-.73-2.134Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.402 6.853c1.172 0 2.594-.327 2.594-2.134 0-1.518-.98-2.23-2.44-2.23h-4.172c-.46 0-.846.058-.846.731v3.633h4.864Zm-4.864 7.957c0 .712-.576 1.058-1.114 1.058-.827 0-1.077-.654-1.077-1.038V2.509c0-1.346.596-2.133 2.057-2.133h5.44c2.94 0 4.42 2.017 4.42 4.305 0 1.192-.402 2.402-1.326 3.21-.846.73-1.634.846-2.286.94.556.348.96.77 1.286 1.308l2.365 3.902c.231.385.27.673.27.808a1.07 1.07 0 0 1-1.097 1.037c-.576 0-.846-.21-1.095-.653l-1.807-3.114c-.96-1.672-1.826-3.152-3.133-3.152h-2.903v5.843Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.622 9.524 53.2 2.432l-2.442 7.092-.73 2.134-1.153 3.364c-.039.115-.326.865-1.057.865-1.173 0-1.21-1-1.21-1.134 0-.174.037-.308.095-.48l4.69-12.86C51.816.26 52.508.028 53.258.028c.326 0 1.23 0 1.73 1.383l4.709 12.86c.038.116.096.307.096.519 0 .654-.5 1.076-1.192 1.076-.557 0-.923-.346-1.095-.845l-1.154-3.364-.73-2.134Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.963 6.853c1.173 0 2.595-.327 2.595-2.134 0-1.518-.98-2.23-2.44-2.23h-4.172c-.461 0-.845.058-.845.731v3.633h4.862Zm-4.862 7.957c0 .712-.578 1.058-1.116 1.058-.826 0-1.076-.654-1.076-1.038V2.509c0-1.346.596-2.133 2.056-2.133h5.44c2.94 0 4.421 2.017 4.421 4.305 0 1.192-.403 2.402-1.326 3.21-.846.73-1.634.846-2.287.94.557.348.96.77 1.287 1.308l2.364 3.902c.232.385.27.673.27.808a1.07 1.07 0 0 1-1.096 1.037c-.576 0-.846-.21-1.096-.653l-1.806-3.114c-.96-1.672-1.826-3.152-3.133-3.152h-2.902v5.843Z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.31 3.064v11.88c0 .365-.25 1.056-1.096 1.056-.48 0-1.076-.307-1.076-1.037V2.142c0-.577.366-1.98 1.826-1.98a2 2 0 0 1 1.808 1.154l5.439 11.782V1.218c0-.364.25-1.056 1.096-1.056.498 0 1.076.308 1.076 1.038v12.82c0 .577-.346 1.98-1.808 1.98a2.007 2.007 0 0 1-1.826-1.153L65.31 3.064Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.71 6.967c.749 0 1.921.403 1.921 1.998v2.018c0 3.288-2.883 5.017-6.208 5.017-5.382 0-7.112-4.555-7.112-7.803 0-4.19 2.575-8.035 7.073-8.035 3.614 0 5.786 2.479 5.786 3.46 0 .538-.346 1.095-1 1.095-.519 0-.769-.268-.923-.46-.884-1.02-1.652-1.923-3.806-1.923-3.306 0-4.844 2.864-4.844 5.843 0 3.73 2.25 5.594 4.941 5.594 2.883 0 3.902-1.864 3.902-2.845V9.657c0-.346-.193-.558-.539-.558H84c-.48 0-1.018-.422-1.018-1.114 0-.922.864-1.018.962-1.018h4.766Z",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.045 6.678c.365 0 1.058.25 1.058 1.057 0 .692-.481 1.058-.981 1.058h-5.863v4.036c0 .268.154.634.596.634h5.806c.19 0 1.133.058 1.133 1.134 0 .654-.499 1.058-1.095 1.058h-6.804c-1.269 0-1.846-.77-1.846-2.115V2.488c0-1.192.692-1.98 1.827-1.98h6.707c.73 0 1.173.442 1.173 1.134 0 .672-.538 1.058-1.115 1.058H96.76c-.384 0-.5.326-.5.672v3.306h5.786Z",
    id: "Fill-15"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArrange);
export default __webpack_public_path__ + "static/media/logo-arrange.e19919a1.svg";
export { ForwardRef as ReactComponent };